import { api } from "./index";

export async function createUpload(image) {
  try {
    const presignedResponse = await api.get("/partners/presigned_s3_url?random=" + Math.random(), {
      params: {
        contentType: 'application/octet-stream',
      }
    });
    const presignedData = presignedResponse.data;

    const uploadResponse = await fetch(presignedData.presigned_url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/octet-stream',
      },
      body: image,
    });

    if (!uploadResponse.ok) {
      throw new Error('Failed to upload image');
    }

    return {
      data: {
        file_name: presignedData.presigned_url.split('?')[0].split('/').pop(),
      }
    };
  } catch (error) {
    console.error('Error uploading image:', error);
    throw error;
  }
}
